// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2syDk","label":"LabeledBox_label__3Whfg"};